import { call, put, takeLatest } from 'redux-saga/effects';

import { feedbackActions } from '../actions/feedback';
import * as api from '../api/feedback';

const { feedbackRequest, feedbackRequestSucceeded, feedbackRequestFailed } =
  feedbackActions;

export const feedback = [
  takeLatest(
    feedbackRequest.toString() as any,
    genWithPromise(
      api.requestFeedback,
      feedbackRequestSucceeded,
      feedbackRequestFailed,
    ),
  ),
];

function genWithPromise(
  apiAction: (action: any) => any,
  resultSucceededAction: (result: any) => any,
  resultFailedAction: (result: any) => any,
) {
  return function* (action: {
    payload: any;
    meta: { resolve: () => void; reject: () => void };
  }) {
    let result;

    try {
      result = yield call(apiAction, action.payload);
      yield put(resultSucceededAction(result));
    } catch (exception) {
      console.error(exception);
      result = exception;
      yield put(resultFailedAction(result));
    }
  };
}
